import { Link } from "react-router-dom";
export default function NotFound() {
  return (
    <div className="min-h-[60vh] flex items-center justify-center py-24" data-testid="page-notfound">
      <div className="text-center max-w-lg">
        <div className="marker-num text-8xl mb-4">404</div>
        <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3">Halaman tidak ditemukan</h1>
        <p className="text-slate-600 mb-8">Halaman yang Anda cari mungkin telah dipindahkan atau tidak lagi tersedia.</p>
        <Link to="/" className="btn-primary">Kembali ke Beranda</Link>
      </div>
    </div>
  );
}
